var path = 'msi/items/remove-item/remove-item.html';
var html = "<a ng-click=\"$ctrl.removeItem($ctrl.item)\" href=\"javascript:void(0);\">\n  {{'REMOVE_ITEM' | translate}}\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;